import type { FaireProductEntity } from "../../entity_types/product";

export const p_p4k4twqva9: FaireProductEntity = {
  token: "p_p4k4twqva9",
  type: "product",
  name: "vintage camera mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/60b6759ce69e924fd592249ef6f7d792e5c9f3e4c94597bee259aaca1dfc222f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e027aa320edb7653e00ccb811ad639d11f61850613f8871d7b037f5a451aebd0.jpeg",
    "https://cdn.faire.com/fastly/9dec1c7fde064c0de84fdc549961fcefbf36c937aaad904d9704db911d0d61d0.jpeg",
    "https://cdn.faire.com/fastly/80029d8e40de659340fc375ccfe1ecda44c5d04be7807ba76827f112cadc3e87.jpeg",
    "https://cdn.faire.com/fastly/c4e037c54ef32cad11b06a7fc1afd3e07929e38e3dfecd4f79ba1f401945a123.jpeg",
    "https://cdn.faire.com/fastly/49cb22efc7ba1cc6e016f40002ebc2168af2d9130e6559f56295f9f2e2e13a06.jpeg",
  ],
  priceDollars: 3,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty presentation. \n\n\nDetails:\n\n- single card + envelope + sticker for sealing\n- blank inside\n- 2.5" x 3.5"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:07.638Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
